import React, { memo, useEffect } from "react";
import stylesPc from "./VideoSuggestionsPanel.module.css";
import stylesSp from "./VideoSuggestionsPanel_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";
import VideoSuggestion from "./VideoSuggestion";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { getAllContents } from "../../../../common/video/VideoActions";
import { t } from "i18next";
const MAX_SUGGESTION_COUNT = 3;

interface VideoSuggestionsPanelProps {
    videoId?: number;
}

function VideoSuggestionsPanel({ videoId }: VideoSuggestionsPanelProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { userInfo, allVideos, videoList } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        allVideos: state.video.allVideos,
        videoList: state.video.videoList,
    }));

    const dispatch = useDispatch();
    const otherVideoIds = videoList.filter((video) => video.id !== videoId);

    useEffect(() => {
        if (allVideos.length === 0 && userInfo) {
            // 全Videoを取得
            dispatch(getAllContents(userInfo.id));
        }
    }, [dispatch, allVideos, userInfo]);

    return (
        <div className={styles.root}>
            <PuiTypography color={"white"} bold={true} size={20}>
                {t("新着動画")}
            </PuiTypography>
            <div className={styles.list}>
                {otherVideoIds && otherVideoIds.length > 0 ? (
                    otherVideoIds
                        .slice(0, MAX_SUGGESTION_COUNT)
                        .map(
                            (video) =>
                                video &&
                                video.visibleNewIcon && (
                                    <VideoSuggestion key={video.id} video={video} />
                                )
                        )
                ) : (
                    <div style={{ color: "var(--primary-font)" }}>{t("新着動画がありません")}</div>
                )}
            </div>
        </div>
    );
}

export default memo(VideoSuggestionsPanel);
